import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/header';

const initialState = fromJS({
  selectedRightOptionsItem: null,
});

export default function header(state = initialState, action = {}) {
  if (action.type === actions.SELECT_RIGHT_OPTIONS_ITEM) {
    const { menu, force } = action.payload;

    if (force) {
      return state.set('selectedRightOptionsItem', menu);
    }

    const currentItem = state.get('selectedRightOptionsItem');

    if (currentItem === menu) {
      return state.set('selectedRightOptionsItem', null);
    }

    return state.set('selectedRightOptionsItem', menu);
  }

  return state;
}
